/**
 *
 */
import { isEmpty } from '../utility/helper';

(function() {
    /**
     * Servizio di storage delle label
     */
    angular.module('cbl.mitomanager.wa').service('MitomLabelSrvc', [
        function() {
            this.labels = [];
            this.develop = true;
            this.loading = true;
            this.labelsPronte = null;

            this.getLabel = (label) => {
                let res = this.labels[label];
                if (!isEmpty(res)) {
                    return res;
                }

                return 'UNDEFINED LABEL' + (this.develop ? ` [${label}]` : '');
            };
        }
    ]);

    /**
     * Pipe label
     * @return {function(*, *)}
     */
    angular.module('cbl.mitomanager.wa').filter('MitomLabel', [
        'MitomLabelSrvc',
        function(labelSrvc) {
            // passing another argument
            return (value) => {
                const newValue = labelSrvc.getLabel(value);
                return newValue;
            };
        }
    ]);
})();